<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<vxe-grid ref="toolbaremunList" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import Sortable from 'sortablejs'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '枚举',
				modal_width:600,
				modal_height:500,
				list_autorender:false
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_init() {
				
				this.init_formButton()
				let list_gridOptions = this.list_getOption()
				const beforeCreateResult = this.list_beforeCreateGrid(list_gridOptions)
				if (beforeCreateResult && typeof beforeCreateResult.then === 'function') {
					beforeCreateResult.then(() => {
						this.list_gridOptions = list_gridOptions
						this.rowDrop()
					})
				} else {
					this.list_gridOptions = list_gridOptions
					this.rowDrop()
				}
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.height = 450
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [ {
						title: '拖动',
						width:60,
						slots:{
							default:()=>{
								return <span class="drag-btn"><i class="vxe-icon-edit"></i></span>
							}
						}

					},{
						field: 'value',
						title: '值',
						editRender: {
							name: '$input',
							props: {},
							events: {}
						},
					}, {
						field: 'label',
						title: '标签',
						editRender: {
							name: '$input',
							props: {},
							events: {

							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					value: [{
						required: true
					}],
					label: [{
						required: true
					}]
				}
				
				
			},
			list() {
				// return new Promise((resolve) => {
				// 	let options = this.data.options ? this.data.options : []
				// 	resolve({
				// 		list: JSON.parse(JSON.stringify(options))
				// 	})
				// })
			},
			modal_init(){
				this.$emit('show')
				this.list_init()
			},	
			rowDrop() {
				this.$nextTick(() => {
					let xTable = this.getgrid()
					let options = this.data.options ? this.data.options : []
					xTable.reloadData(options).then(()=>{						
						this.sortable1 = Sortable.create(xTable.$el.querySelector(
							'.body--wrapper>.vxe-table--body tbody'), {
							handle: '.drag-btn',
							onEnd: ({
								newIndex,
								oldIndex
							}) => {
								let tableData = xTable.getTableData().tableData
								const currRow = tableData.splice(oldIndex, 1)[0]
								tableData.splice(newIndex, 0, currRow)
								xTable.reloadData(tableData)
								
							}
						})
					})
				})
			},
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
				
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.toolbaremunList
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.getgrid().validate(true, (res) => {
					if (!res) {
						let detail = this.getgrid().getTableData().tableData
						this.$emit('success', {data: detail})
						this.modal_cancel()
					} else {
						for (let i in res) {
							console.log(res[i][0].rule)
							let content = res[i][0].rule.$options.content
							let message = res[i][0].rule.$options.message
							if(content){
								this.$message.error(content)
							}else if(message){
								this.$message.error(message)
							}else{
								this.$message.error('缺少必填项：' + res[i][0].column.title)
							}
						}
					}
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>